import React, { Component } from 'react';
import { Query } from '@apollo/react-components';
import routes from '@achievable-me/tundra-wizard/routes';
import { gql } from '@apollo/client';
import { Redirect } from 'react-router-dom';
import { reverse } from 'named-urls';
import SpinnerError from '$components/library/SpinnerError';
import NotFound from '$components/NotFound';
import styles from './styles.scss';

const FIND_CONTENT = gql`
  query FindContent($input: FindContentInput!) {
    findContent(input: $input) {
      content {
        uuid
        slug
      }
    }
  }
`;

class ProductContentNotFound extends Component {
  render() {
    const { product, contentUuid } = this.props;
    const { uuid: productUuid, slug: productSlug } = product;

    return (
      <Query query={FIND_CONTENT} variables={{ input: { productUuid, contentUuid } }}>
        {({ loading, error, data }) => {
          if (loading || error) {
            return (
              <div className={styles.layout}>
                <SpinnerError error={error} />
              </div>
            );
          }

          const { findContent } = data;

          if (findContent) {
            const { content } = findContent;
            return (
              <Redirect
                to={reverse(routes.study.learn, {
                  productSlug,
                  contentUuid: content.slug,
                })}
              />
            );
          }

          return (
            <NotFound
              linkText="Exam overview"
              linkTo={reverse(routes.study.overview, { productSlug })}
            />
          );
        }}
      </Query>
    );
  }
}

export default ProductContentNotFound;
